import React from 'react'
import PropTypes from 'prop-types'
import { Spacing50 } from 'styles/sharedStyle'
import SectionHeader from 'components/SectionHeader'
import { useComponentId } from 'utils/optimizely'
import HomeGridCard from './HomeGridCard'
import { fixAudiences } from '../../utils/audiences'
import { Grid, Wrapper } from './HomeGrid.style'

const HomeGrid = ({ audiences, cards, eyebrow, headline, villageSlug }) => {
  const hasAudiences = !!audiences
  const elementId = useComponentId(`Comp_grid_homepage_GRD01`)

  return (
    <Wrapper
      hasAudience={hasAudiences}
      id={elementId}
      className={fixAudiences(audiences)}>
      <Spacing50 />
      <SectionHeader eyebrow={eyebrow} title={headline} />
      <Grid>
        {cards.map((card, i) => (
          <HomeGridCard
            {...card}
            key={`card_${i.toString()}`}
            compHeadline={headline}
            villageSlug={villageSlug}
          />
        ))}
      </Grid>
      <Spacing50 />
    </Wrapper>
  )
}

HomeGrid.propTypes = {
  audiences: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  eyebrow: PropTypes.string,
  headline: PropTypes.string,
  villageSlug: PropTypes.string,
}

HomeGrid.defaultProps = {
  audiences: '',
  eyebrow: '',
  headline: '',
  villageSlug: '',
}

export default HomeGrid
